/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Team • 50+ members',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Team • 50+ members, including you',
  'fabric.elements.mentions.team.member.count': 'Team • {0, plural, one {1 member} other {{0} members}}',
  'fabric.elements.mentions.team.member.count.including.you': 'Team • {0, plural, one {1 member} other {{0} members}}, including you',
  'fabric.elements.mentions.xproduct.mention.description': 'Needs access to Confluence',
  'fabric.mention.error.defaultAction': 'Try again in a few seconds',
  'fabric.mention.error.defaultHeadline': 'Something went wrong',
  'fabric.mention.error.differentText': 'Try entering different text',
  'fabric.mention.error.loginAgain': 'Try logging out then in again',
  'fabric.mention.noAccess.label': 'No access',
  'fabric.mention.noAccess.warning': "{name} won't be notified as they have no access",
  'fabric.mention.unknow.user.error': 'Unknown user {userId}'
};